import type { InputFieldSize } from "../types/inputfield";
import {
	formControlHeight,
	formFieldDisabledBg,
	formFieldDisabledTextColor,
	formFieldPlaceholderColor,
	textFieldControlSx,
} from "@config/theme/formControls";

const presetSizes = new Set(["small", "medium", "large"]);

const resolveControlSize = (size: InputFieldSize) => {
	if (typeof size === "object" && size !== null) {
		return size;
	}
	return presetSizes.has(size) ? formControlHeight : formControlHeight;
};

export const TextFieldStyles = (
	isClickable: boolean | undefined,
	size: InputFieldSize = "medium",
	error?: boolean,
): Record<string, unknown> => {
	const controlSize = resolveControlSize(size);
	const base = textFieldControlSx(error, controlSize) as Record<string, unknown>;
	const baseInput = (base["& input, & textarea"] as Record<string, unknown>) ?? {};

	return {
		...base,
		cursor: isClickable ? "pointer" : "text",

		"& .MuiOutlinedInput-root.Mui-disabled": {
			backgroundColor: `${formFieldDisabledBg} !important`,
			opacity: 1,
			cursor: "not-allowed",
		},

		"& input, & textarea": {
			...baseInput,
			cursor: isClickable ? "pointer" : "text",
			"&.Mui-disabled": {
				WebkitTextFillColor: formFieldDisabledTextColor,
				color: formFieldDisabledTextColor,
				opacity: 1,
				cursor: "not-allowed",
			},
			"&.Mui-disabled::placeholder": {
				WebkitTextFillColor: formFieldPlaceholderColor,
				color: formFieldPlaceholderColor,
				opacity: 1,
			},
		},

		"& input[type='date']": {
			"&:invalid": {
				color: formFieldPlaceholderColor,
			},
			"&::-webkit-datetime-edit": {
				color: formFieldPlaceholderColor,
			},
			"&:valid::-webkit-datetime-edit": {
				color: formFieldDisabledTextColor,
			},
			"&.Mui-disabled:valid::-webkit-datetime-edit": {
				color: formFieldDisabledTextColor,
				WebkitTextFillColor: formFieldDisabledTextColor,
			},
			"&::-webkit-calendar-picker-indicator": {
				opacity: 0.6,
			},
		},

		"&.Mui-focused .MuiInputAdornment-root svg": {
			color: "#026CB5",
		},
		"&.Mui-error .MuiInputAdornment-root svg": {
			color: "#d32f2f",
		},
		"& .MuiInputAdornment-positionStart": {
			marginRight: "0px",
		},
		"& .MuiInputAdornment-positionEnd": {
			marginLeft: "0px",
		},
		"& .MuiFormHelperText-root": {
			marginTop: "4px",
			fontSize: "11px",
			marginLeft: "0px",
			fontFamily: "Poppins, sans-serif",
			color: error ? "#d32f2f" : "#6B7280",
			lineHeight: 1,
		},
	};
};
